import { Stack } from '@mui/material';
import { CpgReport } from '../../api/schema';
import { SummaryCard, SummaryCardProps } from './SummaryCard';
import { ALL_RETAILERS_NAME } from '../../domain/retailers';
import {
  PerformanceOverTimeCard,
  PerformanceOverTimeCardProps,
} from './PerformanceOverTime/PerformanceOverTimeCard';
import { memo } from 'react';

type PerformanceByRetailerProps = {
  allReports: PerformanceOverTimeCardProps['reports'];
  report: Pick<
    CpgReport,
    | 'impressions'
    | 'uniqueUsers'
    | 'projectedIncrementalSales'
    | 'incrementalSalesLift'
    | 'incrementalSalesLiftConfidenceLevel'
    | 'totalProjectedSales'
    | 'averagePricePerTransaction'
    | 'averageTotalBasketAmount'
    | 'penetration'
    | 'totalSalesRate'
    | 'averagePurchaseFrequency'
  > & {
    retailers: (SummaryCardProps['retailers'][number] &
      PerformanceOverTimeCardProps['latestRetailers'][number])[];
  };
};

export const PerformanceByRetailer = memo(
  (props: PerformanceByRetailerProps) => {
    return (
      <Stack direction="column" gap="1rem">
        <SummaryCard
          retailers={[
            {
              ...props.report,
              id: 0,
              name: ALL_RETAILERS_NAME,
              salesLiftIndex: 1,
              statisticallySignificant: true,
              salesRate: props.report.totalSalesRate ?? null,
              hidden: false,
            },
            ...props.report.retailers,
          ]}
          overallTotalProjectedSales={props.report.totalProjectedSales}
          overallProjectedIncrementalSales={
            props.report.projectedIncrementalSales
          }
        />
        <PerformanceOverTimeCard
          reports={props.allReports}
          latestRetailers={props.report.retailers.filter(
            retailer => retailer.statisticallySignificant
          )}
        />
      </Stack>
    );
  }
);

PerformanceByRetailer.displayName = 'PerformanceByRetailer';
